import React, { Component } from "react";
import { connect } from "react-redux";
import Axios from "axios-https-proxy-fix";
import { Dropdown } from "semantic-ui-react";
import SettingsWrapper from "../../../components/Settings/SettingsWrapper";
import "./Dashboard.scss"
import translator from "../../../utils/translator";

export class Dashboard extends Component {
	state = {
        response: {},
        year: 0,
        total_users: 0,
        user_logins: [],
        monthly_logins: [],
        total_logins: 0,
        users_edited: 0,
        monthly_projects: [],
        monthly_project_totals: [],
        monthly_sent_totals: []
    };
    
    startYear = 2018;

	// ============= AJAX FUNCTIONS =============

	callAjax = async (route, data) => {
		data.trendId = localStorage.getItem("trendId");
		data.token = localStorage.getItem("token");

		let APIResponse = await Axios.post(this.props.APIUrl + route, data);

		if (APIResponse.data.hasOwnProperty("error")) {
			this.setState({ response: { error: APIResponse.data.error } });
			return false;
		}
		return APIResponse.data;
    };
    
    getDashboard = async year => {
        this.setState({ response: { loadingbar: translator("Misc", "loading_label") } });
        let responses = await Promise.all([
            this.callAjax("/settings/get-dashboard", { year: year }),
            this.callAjax("/settings/get-monthly-project-totals", { year: year }),
            this.callAjax("/settings/get-monthly-sent-totals", { year: year })
        ]);
        this.setState({ 
            response:           {},
            year:               year,
            total_users:        responses[0].total_users,
            user_logins:        responses[0].user_logins,
            monthly_logins:     responses[0].monthly_logins,
            total_logins:       responses[0].total_logins,
            users_edited:       responses[0].users_edited,
            monthly_projects:   responses[0].monthly_projects,

            monthly_projects_totals:    responses[1].monthly_projects_totals,
            monthly_sent_totals:        responses[2].monthly_sent_totals
        });
    };
    
    // ============= RENDER FUNCTIONS =============
    
    renderYears = state => {
        let year_options = [];
        for(let year = this.startYear; year <= (new Date()).getFullYear(); year++) {
            year_options.push({ value: year, text: year });
        }
		return (
			<div class="card user-profile-card mb1">
				<div class="card-body">
                    <Dropdown
                        fluid
                        selection
                        placeholder={translator("Misc", "select_label")}
                        options={year_options}
                        onChange={(e, d) => this.getDashboard(d.value)}
                    />
				</div>
			</div>
		);
	};

	renderDashboard = state => {
        const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
		return (
			<div class="card user-profile-card mb1">
				<div class="card-body">
                <div className="section">
                        <div className="header">Year</div>
                        <div className="form-control">{state.year}</div>
                    </div>
                    <div className="section">
                        <div className="header">Total Users</div>
                        <div className="form-control">{state.total_users}</div>
                    </div>
                    <div className="section">
                        <div className="header">Logins Per Month</div>
                        <table className="month-table">
                            <tbody>
                                {state.monthly_logins.map(month => (
                                    <tr>
                                        <td>{month.name}</td>
                                        <td>{month.total}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="section">
                        <div className="header">Total Logins</div>
                        <div className="form-control">{state.total_logins}</div>
                    </div>
                    <div className="section">
                        <div className="header">Accounts Edited</div>
                        <div className="form-control">{state.users_edited}</div>
                    </div>
                    <div className="section">
                        <div className="header">Projects Created</div>
                        <table className="month-table">
                            <tbody>
                                {state.monthly_projects.map(month => (
                                    <tr>
                                        <td>{month.name}</td>
                                        <td>{month.total}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="section">
                        <div className="header">Projects Totals</div>
                        <table className="month-table money-table">
                            <tbody>
                                {state.monthly_projects_totals.map(month => (
                                    <tr>
                                        <td>{month.name}</td>
                                        <td>{formatter.format(month.total)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="section">
                        <div className="header">Sent to Trend</div>
                        <table className="month-table money-table">
                            <tbody>
                                {state.monthly_sent_totals.map(month => (
                                    <tr>
                                        <td>{month.name}</td>
                                        <td>{formatter.format(month.total)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="section">
                        <div className="header">Unique Logins</div>
                        <table className="user-table">
                            <tbody>
                                {state.user_logins.map(user => (
                                    <tr>
                                        <td>{user.id}</td>
                                        <td>{user.name}</td>
                                        <td>{user.total}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
				</div>
			</div>
		);
	};

	renderResponse = response => {
		if (Object.keys(response).length === 0) return null;
		let key = "error";
		if (response.hasOwnProperty("success")) key = "success";
		if (response.hasOwnProperty("loadingbar")) key = "loadingbar";
		let cardClass = "card user-profile-card response-" + key;
		return (
			<div className={cardClass}>
				<div class="card-body">{response[key]}</div>
			</div>
		);
	};

	render() {
		let state = this.state;
		let main = (
			<>
				{this.renderYears(state)}
				{Object.keys(state.response).length ? this.renderResponse(state.response) : null}
                {state.year ? this.renderDashboard(state) : null}
			</>
		);
		return (
			<SettingsWrapper header={translator("Admin Menu", "dashboard_title")} main={main} classes="settings-dashboard"/>
		);
	}
}

const mapStateToProps = state => ({
	APIUrl: state.APIUrl
});

const mapDispatchToProps = {};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Dashboard);
